// #region Dados mock
let _data = [
  { id: 1001, funcionario_id: 102, venda_id: 1, data_competencia: '2024-01-14', valor: 37.50, pago: true },
  { id: 1002, funcionario_id: 104, venda_id: 2, data_competencia: '2024-01-14', valor: 22.38, pago: false },
  { id: 1003, funcionario_id: 102, venda_id: 3, data_competencia: '2024-01-15', valor: 81.20, pago: true },
  { id: 1004, funcionario_id: 101, venda_id: 4, data_competencia: '2024-01-16', valor: 45.00, pago: false },
  { id: 1005, funcionario_id: 105, venda_id: 5, data_competencia: '2024-01-16', valor: 55.10, pago: true },
  { id: 1006, funcionario_id: 102, venda_id: 6, data_competencia: '2024-01-17', valor: 85.02, pago: false },
];
// #endregion

// #region Util
const delay = (ms = 240) => new Promise(r => setTimeout(r, ms));
// #endregion

// #region CRUD
export async function listAll() { await delay(); return _data.map(c => ({ ...c })); }
export async function getById(id) { await delay(); const found = _data.find(c => c.id === id); return found ? { ...found } : null; }
export async function create(payload) { await delay(); const id = Date.now(); const novo = { id, ...payload }; _data = [novo, ..._data]; return { ...novo }; }
export async function update(id, patch) { await delay(); let updated = null; _data = _data.map(c => { if (c.id === id) { updated = { ...c, ...patch }; return updated; } return c; }); return updated ? { ...updated } : null; }
export async function remove(id) { await delay(); _data = _data.filter(c => c.id !== id); return true; }
export async function toggleStatus(id) { await delay(); let updated = null; _data = _data.map(c => { if (c.id === id) { updated = { ...c, pago: !c.pago }; return updated; } return c; }); return updated ? { ...updated } : null; }
// #endregion

// #region Export default
const comissoesApi = { listAll, getById, create, update, remove, toggleStatus };
export default comissoesApi;
// #endregion
